import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportDto } from 'src/models/ts/report-dto.model';
import { CollectionForm } from '../../../../models/ts/collection-form.model';
import { OAuthStorage } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class ReportApiService {

  public constructor(private http: HttpClient) { }

  private oAuthStorage = inject(OAuthStorage);

  public getDetails(reportId: number): Observable<ReportDto> {
    return this.http.get<ReportDto>(`api/report/${reportId}/detail`);
  }

  public exportListReportPdf(reportId: number, listId: number, folderId:number,  details: ReportDto): Observable<ArrayBuffer>{
    return this.http.post(`api/report/${reportId}/list/${listId}/folder/${folderId}/pdf`, details, {responseType: 'arraybuffer'});
  }

  public exportReportPdf(reportId: number, instanceId: number, versionId: number,  details: ReportDto, guidChecksum: string | undefined): Observable<ArrayBuffer>{
    return this.http.post(`api/report/${reportId}/instance/${instanceId}/version/${versionId}/pdf`.appendChecksum(guidChecksum), details, {responseType: 'arraybuffer' });
  }

  public getForm(reportId: number, instanceId: number, versionId: number, themeId: number, guidChecksum: string | undefined): Observable<CollectionForm> {
    return this.http.get<CollectionForm>(`api/report/${reportId}/instance/${instanceId}/version/${versionId}/theme/${themeId}`.appendChecksum(guidChecksum));
  }

 /* https://localhost:6814/api/report/5/collection/532/list/376/folder/0/searchfilter/0/parentfilter/0/theme/1/pdf*/
  public getList(reportId: number, collectionId: number, listId: number, folderId: number, searchfilterId: number, parentfilterId: number, themeId: number): Observable<CollectionForm[]> {
    return this.http.get<CollectionForm[]>(`api/report/${reportId}/collection/${collectionId}/list/${listId}/folder/${folderId}/searchfilter/${searchfilterId}/parentfilter/${parentfilterId}/theme/${themeId}/pdf`);
  }

  private setReportAuthorizationHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
    return request.clone({
      headers: request.headers.append('Authorization', 'Bearer ' + this.oAuthStorage.getItem('report_access_token'))
    });
  }
}
